import Vue from "vue";

Vue.directive("onlyNum", {
  bind(el, binding, vnode) {
    let ele = el.tagName === "INPUT" ? el : el.querySelector("input");
    ele.oninput = function() {
      let val = ele.value,
        arg = parseInt(binding.arg);
      if (arg) {
        val = val.replace(/[^\d.]/g, ""); //清除"数字"和"."以外的字符
        val = val.replace(/^\./g, ""); //验证第一个字符是数字
        val = val.replace(/\.{2,}/g, "."); //只保留第一个, 清除多余的
        val = val
          .replace(".", "$#$")
          .replace(/\./g, "")
          .replace("$#$", ".");
        let reg = new RegExp(`^(\\-)*(\\d+)\\.(\\d{${arg}}).*$`);
        val = val.replace(reg, "$1$2.$3"); //只能输入三个小数
      } else {
        val = val.replace(/[^\d]/g, "");
      }
      ele.value = val;
    };
  }
});
